import React from 'react';
import { DocumentRecord } from '../../types/document';

interface DocumentListProps {
  documents: DocumentRecord[];
  selectedDocumentId?: number;
  onDocumentSelect: (document: DocumentRecord) => void;
  loading?: boolean;
}

export const DocumentList: React.FC<DocumentListProps> = ({
  documents,
  selectedDocumentId,
  onDocumentSelect,
  loading = false
}) => {
  const listStyle: React.CSSProperties = {
    height: '100%',
    overflowY: 'auto',
    border: '1px solid #ddd',
    borderRadius: '4px'
  };

  const itemStyle: React.CSSProperties = {
    padding: '12px 16px',
    borderBottom: '1px solid #f0f0f0',
    cursor: 'pointer',
    transition: 'background-color 0.2s'
  };

  const selectedItemStyle: React.CSSProperties = {
    ...itemStyle,
    backgroundColor: '#e6f3ff'
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '20px' }}>加载中...</div>;
  }

  if (documents.length === 0) {
    return <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>暂无文档</div>;
  }

  return (
    <div style={listStyle}>
      {documents.map((doc) => (
        <div
          key={doc.id}
          style={doc.id === selectedDocumentId ? selectedItemStyle : itemStyle}
          onClick={() => onDocumentSelect(doc)}
          onMouseEnter={(e) => {
            if (doc.id !== selectedDocumentId) {
              e.currentTarget.style.backgroundColor = '#f5f5f5';
            }
          }}
          onMouseLeave={(e) => {
            if (doc.id !== selectedDocumentId) {
              e.currentTarget.style.backgroundColor = 'transparent';
            }
          }}
        >
          <div style={{ fontWeight: 'bold' }}>{doc.name}</div>
          {doc.date_updated && (
            <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
              更新时间: {new Date(doc.date_updated).toLocaleString()}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};